// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.verification

import org.multipaz.cbor.DataItem
import org.multipaz.verification.Iso18013PresentmentRecord
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Bstr
import org.multipaz.cbor.Tstr
import org.multipaz.crypto.EcPrivateKey

fun Iso18013PresentmentRecord.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "U5qzuUIhMi0yk9KgA-s5Uq1zKevhR3rdwViPlOqq1L4")
val Iso18013PresentmentRecord_cborSchemaId = ByteString(83, -102, -77, -71, 66, 33, 50, 45, 50, -109, -46, -96, 3, -21, 57, 82, -83, 115, 41, -21, -31, 71, 122, -35, -63, 88, -113, -108, -22, -86, -44, -66)

fun Iso18013PresentmentRecord.Companion.fromCbor(data: ByteArray): Iso18013PresentmentRecord {
    return Iso18013PresentmentRecord.fromDataItem(Cbor.decode(data))
}

val Iso18013PresentmentRecord.Companion.cborSchemaId: ByteString
    get() = Iso18013PresentmentRecord_cborSchemaId

fun Iso18013PresentmentRecord.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "Iso18013")
    builder.put("response", this.response)
    builder.put("sessionTranscript", this.sessionTranscript)
    builder.put("request", this.request)
    val encryptionInfo = this.encryptionInfo
    if (encryptionInfo != null) {
        builder.put("encryptionInfo", Bstr(encryptionInfo.toByteArray()))
    }
    val origin = this.origin
    if (origin != null) {
        builder.put("origin", Tstr(origin))
    }
    val eDeviceKey = this.eDeviceKey
    if (eDeviceKey != null) {
        builder.put("eDeviceKey", eDeviceKey.toDataItem())
    }
    return builder.end().build()
}

fun Iso18013PresentmentRecord.Companion.fromDataItem(dataItem: DataItem): Iso18013PresentmentRecord {
    val response = dataItem["response"]
    val sessionTranscript = dataItem["sessionTranscript"]
    val request = dataItem["request"]
    val encryptionInfo0 = if (dataItem.hasKey("encryptionInfo")) {
        dataItem["encryptionInfo"].let { ByteString(it.asBstr) }
    } else {
        null
    }
    val origin0 = if (dataItem.hasKey("origin")) {
        dataItem["origin"].asTstr
    } else {
        null
    }
    val eDeviceKey0 = if (dataItem.hasKey("eDeviceKey")) {
        EcPrivateKey.fromDataItem(dataItem["eDeviceKey"])
    } else {
        null
    }
    return Iso18013PresentmentRecord(
        response = response,
        sessionTranscript = sessionTranscript,
        request = request,
        encryptionInfo = encryptionInfo0,
        origin = origin0,
        eDeviceKey = eDeviceKey0,
    )
}
